<ps-ui-modal class="quota-modal quota-nested-modal">
  <ps-ui-modal-body>
    <div
      class="alert alert-danger"
      role="alert"
      *ngIf="hasMoreQuotasThanCompletes"
    >
      There are more quotas than completes available. Some nested quotas have 0
      quantity available. This may cause unexpected behavior - please revise
      nested quotas if this warning is unexpected.
    </div>
    <div
      class="alert alert-warning"
      role="alert"
      *ngIf="showLiveSurveyWarningMessage"
    >
      The nesting group cannot be changed or removed in a Live Survey. If you
      want to change your nesting group, please pause/close this survey and
      clone
    </div>
    <div class="text-center mx-width">
      <h2 class="header-title">Quota Nesting</h2>
    </div>

    <div class="scroll_table">
      <div class="row">
        <div class="col-3">
          <div class="nesting_options">
            <h5 class="nesting_header">Nested Quotas</h5>
            <div class="nesting_checkbox">
              <tr
                class="all-qual-tr"
                *ngFor="
                  let qualificationForNest of allQualifications;
                  let i = index
                "
              >
                <input
                  *ngIf="qualificationForNest.isVisible"
                  class="m-1 form-check-input"
                  type="checkbox"
                  (change)="toggleQualificationSelection($event, i)"
                  [checked]="qualificationForNest.isChecked"
                  (click)="validateQualificationSelectionLimit($event)"
                  [disabled]="disabledCheckboxesAtLiveSurvey"
                />
                <td
                  class="main-qualification"
                  *ngIf="qualificationForNest.isVisible"
                >
                  {{ qualificationForNest.qualification_name }}
                </td>

                <!-- (change)="addRemoveFromNestingObject(qualificationForNest)" -->

                <!-- commenting this as this should be a work for future, but I disccused after some time -->
                <!-- <td *ngIf="qualificationForNest.totalQuotas">(0/{{ qualificationForNest.totalQuotas}})</td>
                <td *ngIf="qualificationForNest.isVisible">
                  <i *ngIf="!qualificationForNest.showAllQualificationsValue"
                    (click)="enableSubMenu(qualificationForNest.qualification_code, 'down')" class="fa fa-caret-down"
                    aria-hidden="true"></i>
                  <i *ngIf="qualificationForNest.showAllQualificationsValue"
                    (click)="enableSubMenu(qualificationForNest.qualification_code, 'up')" class="fa fa-caret-up"
                    aria-hidden="true"></i>

                </td>
                <td class="single-quota-tr"
                  *ngIf="qualificationForNest.isVisible && qualificationForNest.quotas && qualificationForNest.showAllQualificationsValue">
                <tr *ngFor="let quotasForNest of qualificationForNest.inside; let i = index">
                <input class="m-1 form-check-input" type="checkbox"
                  />
                <td>{{quotasForNest}}</td>

              </tr>
              </td> -->
                <td>
                  <!-- <tr *ngFor="let nestedQuota of nestedQuotas">
                    <td>
                      <span *ngFor="let combinedKey of nestedQuota.combinedKey">
                        {{ combinedKey }}
                      </span>
                    </td>
                    <td>
                      {{
                        nestedQuota.required_count || nestedQuota.number || 0
                      }}
                    </td>
                    <td>{{ nestedQuota.percentage }}</td>
                    <td>{{ nestedQuota.minimum }}</td>
                    <td>{{ nestedQuota.maximum }}</td>
                    <td>{{ nestedQuota.fielded }}</td>
                  </tr> -->
                </td>
              </tr>
            </div>
          </div>
        </div>
        <div class="col-9 nesting_table">
          <div class="nesting_header">
            <h5>Nested Quota Details</h5>
            <div class="nesting_button">
              <span *ngIf="hasTableSelectionMode && selectedNestedQuotas.length"
                >{{ selectedNestedQuotas.length }} selected</span
              >
              <button
                *ngIf="!hasTableSelectionMode"
                [disabled]="!selectedQualifications.length"
                class="btn group_btn"
                (click)="hasTableSelectionMode = true"
                [disabled]="
                  this.surveyDetails &&
                  this.surveyDetails.ps_survey_status === SURVEY_STATUS.LIVE
                "
              >
                Create a Quota Group
              </button>
              <button
                *ngIf="hasTableSelectionMode"
                class="btn group_btn"
                (click)="createGroupNestedQuotas()"
                [disabled]="disabledCheckboxesAtLiveSurvey"
              >
                Done
              </button>
            </div>
          </div>
          <div class="nested-quota-box">
            <table class="nested-quota-table">
              <thead class="nested-quota-head">
                <th></th>
                <th colspan="2">Allocation</th>
                <th colspan="2">Flexibility</th>
                <th>Fielded</th>
                <th>&nbsp;&nbsp;&nbsp;&nbsp;</th>
              </thead>
              <thead class="nested-quota-head bg-dark-table">
                <th>
                  <span></span>
                  <span
                    *ngFor="let selectedQualification of selectedQualifications"
                    >{{ selectedQualification.qualification_name }}</span
                  >
                </th>
                <th>#</th>
                <th>%</th>
                <th>MIN</th>
                <th>MAX</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
              </thead>
              <tbody class="nested-quota-body">
                <tr *ngFor="let nestedQuota of nestedQuotas; index as i">
                  <td colspan="8" *ngIf="nestedQuota.isQuotaGrouped">
                    <table class="responsive nest_accordion">
                      <ps-ui-accordion
                        [closeOthers]="false"
                        [arrowToggleOnly]="false"
                        class="accordian-new-localization"
                      >
                        <ps-ui-accordion-section
                          class="accordian-new-localization-2"
                        >
                          <ng-template psUiAccordionTitle>
                            <thead
                              [ngClass]="{
                                'unicorn-row': shouldShowToolTip(
                                  nestedQuota?.buyer_quota_id
                                )
                              }"
                            >
                              <th>
                                <div
                                  class="hover-edit-trigger"
                                  title="click to edit"
                                >
                                  <div
                                    class="setting-info"
                                    *ngIf="
                                      shouldShowToolTip(
                                        nestedQuota?.buyer_quota_id
                                      )
                                    "
                                  >
                                    <i
                                      class="fa fa-exclamation-circle error-icon me-2"
                                      aria-hidden="true"
                                    ></i>
                                    <p>
                                      {{
                                        Constants.UNICORN_NESTING_TOOLTIP
                                          .HIGHLY_CHALLENGING_QUOTA
                                      }}
                                    </p>
                                  </div>
                                  <div
                                    class="hover-text-field"
                                    *ngIf="!nestedQuota.isEdit"
                                  >
                                    <span>{{ nestedQuota.quota_title }}</span>
                                    <div
                                      class="pencil-outer pencil-outer-qbp"
                                      (click)="
                                        nestedQuota.isEdit = true;
                                        updateQuotanestingEdit(nestedQuota)
                                      "
                                    >
                                      <div class="fa fa-pencil"></div>
                                    </div>
                                  </div>
                                  <input
                                    class="inputText hover-font-color input-qbp-cpi text-center"
                                    type="inputText"
                                    [ngModel]="nestedQuota.quota_title"
                                    (ngModelChange)="
                                      nestedQuota.quota_title = $event
                                    "
                                    *ngIf="nestedQuota.isEdit"
                                  />
                                  <div
                                    class="edit-button-group"
                                    *ngIf="nestedQuota.isEdit"
                                  >
                                    <div
                                      class="fa fa-check glyphicon glyphicon-ok"
                                      (click)="
                                        nestedQuota.isEdit = false;
                                        verifyQuotaTitle(nestedQuota);
                                        disableApplyNestingButton()
                                      "
                                    ></div>
                                    <div
                                      class="fa fa-remove glyphicon glyphicon-remove"
                                      (click)="
                                        nestedQuota.isEdit = false;
                                        nestedQuota.quota_title =
                                          nestedQuota.initialQuotaTitle
                                      "
                                    ></div>
                                  </div>
                                </div>
                              </th>
                              <th>
                                <div *ngIf="!nestedQuota.isAllocationEdit">
                                  {{
                                    nestedQuota.required_count ||
                                      nestedQuota.number ||
                                      0
                                  }}
                                  <div
                                    class="pencil-outer pencil-outer-qbp icon-space"
                                    [ngClass]="{
                                      'edit-disabled':
                                        (!nestedQuota.isAllocationEdit ||
                                          !nestedQuota.isPercentageEdit) &&
                                        isEditModeEnabled
                                    }"
                                    (click)="
                                      nestedQuota.isAllocationEdit = true;
                                      isEditModeEnabled = true;
                                      nestedQuota.initialQuotaAllocation =
                                        nestedQuota.required_count ||
                                        nestedQuota.number ||
                                        0;
                                      nestedQuota.required_count =
                                        nestedQuota.required_count ||
                                        nestedQuota.number ||
                                        0
                                    "
                                  >
                                    <div class="fa fa-pencil"></div>
                                  </div>
                                </div>
                                <div
                                  class="edit-button-group"
                                  *ngIf="nestedQuota.isAllocationEdit"
                                >
                                  <input
                                    class="inputText hover-font-color input-qbp-cpi edit-qouta-input"
                                    type="number"
                                    [ngModel]="nestedQuota.required_count"
                                    (ngModelChange)="
                                      nestedQuota.required_count = $event
                                    "
                                    psUiInputRestriction="[0-9]"
                                    *ngIf="nestedQuota.isAllocationEdit"
                                  />
                                  <div
                                    class="fa fa-check glyphicon glyphicon-ok"
                                    (click)="
                                      nestedQuota.isAllocationEdit = false;
                                      isEditModeEnabled = false;
                                      updateQuotaAllocation(nestedQuota)
                                    "
                                  ></div>
                                  <div
                                    class="fa fa-remove glyphicon glyphicon-remove"
                                    (click)="
                                      nestedQuota.isAllocationEdit = false;
                                      isEditModeEnabled = false;
                                      setInitialAllocation(nestedQuota)
                                    "
                                  ></div>
                                </div>
                              </th>
                              <th>
                                <div *ngIf="!nestedQuota.isPercentageEdit">
                                  {{
                                    nestedQuota.percentage | number : '1.0-0'
                                  }}%
                                  <div
                                    class="pencil-outer pencil-outer-qbp icon-space"
                                    [ngClass]="{
                                      'edit-disabled':
                                        (!nestedQuota.isAllocationEdit ||
                                          !nestedQuota.isPercentageEdit) &&
                                        isEditModeEnabled
                                    }"
                                    (click)="
                                      nestedQuota.isPercentageEdit = true;
                                      isEditModeEnabled = true;
                                      nestedQuota.initialQuotaPercentage =
                                        nestedQuota.percentage
                                    "
                                  >
                                    <div class="fa fa-pencil"></div>
                                  </div>
                                </div>

                                <div
                                  class="edit-button-group"
                                  *ngIf="nestedQuota.isPercentageEdit"
                                >
                                  <input
                                    class="inputText hover-font-color input-qbp-cpi edit-qouta-input"
                                    type="number"
                                    [ngModel]="
                                      nestedQuota.percentage | number : '1.0-0'
                                    "
                                    (ngModelChange)="
                                      nestedQuota.percentage = $event
                                    "
                                    psUiInputRestriction="[0-9]"
                                    max="100"
                                    min="0"
                                    *ngIf="nestedQuota.isPercentageEdit"
                                  />
                                  <div
                                    class="fa fa-check glyphicon glyphicon-ok"
                                    (click)="
                                      nestedQuota.isPercentageEdit = false;
                                      isEditModeEnabled = false;
                                      updateQuotaPercentage(nestedQuota)
                                    "
                                  ></div>
                                  <div
                                    class="fa fa-remove glyphicon glyphicon-remove"
                                    (click)="
                                      nestedQuota.isPercentageEdit = false;
                                      isEditModeEnabled = false;
                                      nestedQuota.percentage =
                                        nestedQuota.initialQuotaPercentage
                                    "
                                  ></div>
                                </div>
                              </th>
                              <th>
                                {{ nestedQuota.minimum | number : '1.0-2' }}
                              </th>
                              <th>
                                {{ nestedQuota.maximum | number : '1.0-2' }}
                              </th>
                              <th>
                                {{ nestedQuota.fielded | number : '1.0-2' }}
                              </th>
                              <th>
                                <button
                                  class="dotsv"
                                  [psUiDropdownToggleFor]="manageDropDown"
                                  *ngIf="!disabledCheckboxesAtLiveSurvey"
                                >
                                  <i
                                    class="fa fa-ellipsis-h"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <ps-ui-dropdown
                                  class="manage-dropdown"
                                  #manageDropDown="psUiDropdown"
                                  [canClose]="true"
                                >
                                  <button
                                    psUiDropdownItem
                                    (click)="ungroupNesedQuotaGroup(i)"
                                  >
                                    Delete
                                  </button>
                                </ps-ui-dropdown>
                              </th>
                            </thead>
                          </ng-template>
                          <ng-template psUiAccordionContent>
                            <tbody class="nested-quota-body">
                              <tr
                                *ngFor="
                                  let individualQuota of nestedQuota.individual_quotas
                                "
                                [ngClass]="{
                                  'unicorn-row': shouldShowToolTip(
                                    nestedQuota?.buyer_quota_id
                                  )
                                }"
                              >
                                <td>
                                  <span></span>
                                  <div
                                    class="setting-info"
                                    *ngIf="
                                      shouldShowToolTip(
                                        nestedQuota?.buyer_quota_id
                                      )
                                    "
                                  >
                                    <i
                                      class="fa fa-exclamation-circle error-icon me-2"
                                      aria-hidden="true"
                                    ></i>
                                    <p>
                                      {{
                                        Constants.UNICORN_NESTING_TOOLTIP
                                          .HIGHLY_CHALLENGING_QUOTA
                                      }}
                                    </p>
                                  </div>

                                  <span
                                    *ngFor="
                                      let combinedKey of individualQuota.combinedKey
                                    "
                                  >
                                    {{ combinedKey }}
                                  </span>
                                </td>
                                <td>
                                  {{ individualQuota.allocation.quantity || 0 }}
                                </td>
                                <td>
                                  {{
                                    individualQuota.allocation.percentage
                                      | number : '1.0-0'
                                  }}%
                                </td>
                                <td>{{ individualQuota.allocation.min }}</td>
                                <td>{{ individualQuota.allocation.max }}</td>
                                <td>
                                  {{ individualQuota.allocation.fielded }}
                                </td>
                                <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                              </tr>
                            </tbody>
                          </ng-template>
                        </ps-ui-accordion-section>
                      </ps-ui-accordion>
                    </table>
                  </td>
                </tr>
                <tr
                  *ngFor="let nestedQuota of nestedQuotas; index as i"
                  [ngClass]="{
                    'unicorn-row': shouldShowToolTip(
                      nestedQuota?.buyer_quota_id
                    )
                  }"
                >
                  <td *ngIf="!nestedQuota.isQuotaGrouped">
                    <span class="nested-checkbox">
                      <input
                        class="m-1 form-check-input"
                        type="checkbox"
                        *ngIf="hasTableSelectionMode"
                        (change)="toggleNestedQuotaSelection($event, i)"
                        [checked]="nestedQuota.isChecked"
                      />
                    </span>
                    <div
                      class="setting-info"
                      *ngIf="shouldShowToolTip(nestedQuota?.buyer_quota_id)"
                    >
                      <i
                        class="fa fa-exclamation-circle error-icon me-2"
                        aria-hidden="true"
                      ></i>
                      <p>
                        {{
                          Constants.UNICORN_NESTING_TOOLTIP
                            .HIGHLY_CHALLENGING_QUOTA
                        }}
                      </p>
                    </div>
                    <span *ngFor="let combinedKey of nestedQuota.combinedKey">
                      {{ combinedKey }}
                    </span>
                  </td>
                  <td *ngIf="!nestedQuota.isQuotaGrouped">
                    <div *ngIf="!nestedQuota.isAllocationEdit">
                      {{
                        nestedQuota.required_count || nestedQuota.number || 0
                      }}
                      <div
                        [ngClass]="{
                          'edit-disabled':
                            (!nestedQuota.isAllocationEdit ||
                              !nestedQuota.isPercentageEdit) &&
                            isEditModeEnabled
                        }"
                        class="pencil-outer pencil-outer-qbp icon-space"
                        (click)="
                          nestedQuota.isAllocationEdit = true;
                          isEditModeEnabled = true;
                          nestedQuota.initialQuotaAllocation =
                            nestedQuota.required_count ||
                            nestedQuota.number ||
                            0;
                          nestedQuota.required_count =
                            nestedQuota.required_count ||
                            nestedQuota.number ||
                            0
                        "
                      >
                        <div class="fa fa-pencil"></div>
                      </div>
                    </div>
                    <div
                      class="edit-button-group"
                      *ngIf="nestedQuota.isAllocationEdit"
                    >
                      <input
                        class="inputText hover-font-color input-qbp-cpi edit-qouta-input"
                        type="number"
                        psUiInputRestriction="[0-9]"
                        [ngModel]="nestedQuota.required_count"
                        (ngModelChange)="nestedQuota.required_count = $event"
                        *ngIf="nestedQuota.isAllocationEdit"
                      />
                      <div
                        class="fa fa-check glyphicon glyphicon-ok"
                        (click)="
                          nestedQuota.isAllocationEdit = false;
                          isEditModeEnabled = false;
                          updateQuotaAllocation(nestedQuota)
                        "
                      ></div>
                      <div
                        class="fa fa-remove glyphicon glyphicon-remove"
                        (click)="
                          nestedQuota.isAllocationEdit = false;
                          isEditModeEnabled = false;
                          setInitialAllocation(nestedQuota)
                        "
                      ></div>
                    </div>
                  </td>
                  <td *ngIf="!nestedQuota.isQuotaGrouped">
                    <div *ngIf="!nestedQuota.isPercentageEdit">
                      {{ nestedQuota.percentage | number : '1.0-0' }}%
                      <div
                        [ngClass]="{
                          'edit-disabled':
                            (!nestedQuota.isAllocationEdit ||
                              !nestedQuota.isPercentageEdit) &&
                            isEditModeEnabled
                        }"
                        class="pencil-outer pencil-outer-qbp icon-space"
                        (click)="
                          nestedQuota.isPercentageEdit = true;
                          isEditModeEnabled = true;
                          nestedQuota.initialQuotaPercentage =
                            nestedQuota.percentage
                        "
                      >
                        <div class="fa fa-pencil"></div>
                      </div>
                    </div>

                    <div
                      class="edit-button-group"
                      *ngIf="nestedQuota.isPercentageEdit"
                    >
                      <input
                        class="inputText hover-font-color input-qbp-cpi edit-qouta-input"
                        type="number"
                        psUiInputRestriction="[0-9]"
                        [ngModel]="nestedQuota.percentage | number : '1.0-0'"
                        (ngModelChange)="nestedQuota.percentage = $event"
                        max="100"
                        min="0"
                        *ngIf="nestedQuota.isPercentageEdit"
                      />
                      <div
                        class="fa fa-check glyphicon glyphicon-ok"
                        (click)="
                          nestedQuota.isPercentageEdit = false;
                          isEditModeEnabled = false;
                          updateQuotaPercentage(nestedQuota)
                        "
                      ></div>
                      <div
                        class="fa fa-remove glyphicon glyphicon-remove"
                        (click)="
                          nestedQuota.isPercentageEdit = false;
                          isEditModeEnabled = false;
                          nestedQuota.percentage =
                            nestedQuota.initialQuotaPercentage
                        "
                      ></div>
                    </div>
                  </td>
                  <td *ngIf="!nestedQuota.isQuotaGrouped">
                    {{ nestedQuota.minimum }}
                  </td>
                  <td *ngIf="!nestedQuota.isQuotaGrouped">
                    {{ nestedQuota.maximum }}
                  </td>
                  <td *ngIf="!nestedQuota.isQuotaGrouped">
                    {{ nestedQuota.fielded }}
                  </td>
                  <td>&nbsp;</td>
                </tr>
                <tr class="fw-bold" *ngIf="selectedQualifications.length">
                  <td class="text-end pe-2">Total Remaining</td>
                  <td>
                    {{ totalRemaining }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="alert alert-warning"
      role="alert"
      *ngIf="showDraftSurveyWarningMessage"
    >
      Important! The nesting group cannot be changed or removed after the
      project is Live. Make sure to save the project with your latest nesting
      group quota configuration. However, if you only nest the quota, you can
      change it at any time.
    </div>
    <div class="row margin-top-20">
      <div class="col-3">
        <button
          psUiButton
          color="primary"
          type="button"
          class="clearbutton"
          (click)="clearNesting()"
          [disabled]="disabledCheckboxesAtLiveSurvey"
        >
          Clear Nesting
        </button>
      </div>

      <div class="col-9">
        <button
          psUiButton
          color="primary"
          class="applybutton"
          type="button"
          style="float: right"
          (click)="applyNesting()"
          [disabled]="
            disableApplyNesting ||
            disabledCheckboxesAtLiveSurvey ||
            totalRemaining > 0
          "
        >
          Apply Nesting
        </button>
      </div>
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>
